module.exports = __webpack_public_path__ + "img/engineer2.488fad15.jpeg";